import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { WishList } from 'app/shared/models/class/wishlist/wishlist';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WishlistService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getWishList(userKey: number): Observable<FullOffer[]> {
    return this.http.get<FullOffer[]>(`${environment.apiUrl}/WishList/${userKey}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateWishList(wishList: WishList): Observable<FullOffer[]> {
    const formData = new FormData();
    formData.append('wishListString', JSON.stringify(wishList));

    return this.http.put<FullOffer[]>(`${environment.apiUrl}/WishList/UpdateWishList`, formData);
  }

}
